<template>
	<div id="downloadwrap">
		<div class="downloadmain">
			<div class="downloadlogo">
				<div class="">安装包下载</div>
			</div>
			<h3>{{sdkName}}</h3>
			<h6>{{sdkAbstract}}</h6>
			<div class="sdkcircle">
				<h4 >{{sdkName}}</h4>
				<h5 >{{sdkSize}}</h5>
			</div>
			<ul>
				<li>
					<router-link to="/developdocument">
						查看开发文档
					</router-link>
				</li>
				<li style="color: #fff;">
					<router-link to="/graph">
					查看案例
					</router-link>
				</li>
					<li style="color: #fff;">
					<router-link to="/pricing">
					下载安装包
					</router-link>
				</li>
				<!-- <li style="cursor: pointer;" @click="download">下载安装包</li> -->
			</ul>
		</div>
	</div>
</template>

<script>
	export default{
		data() {
			return {
				bodyheight:'',
				sdkName:'',			//sdk名称
				sdkAbstract:'',		//sdk简介
				sdkSize:'',			//sdk大小
				sdkUrl:'',			//sdk路径
				sdkEdition:''		//sdk版本
			}
		},
		mounted(){
			this.$nextTick(function(){
				let demo=document.getElementById('demo');
				demo.className = 'el-menu-item'
				demo.style.color='rgb(255, 255, 255)';
				demo.style.borderBottomColor='transparent';
			});
			//获取数据
			
			let _this=this;
			this.$http.get(
				_this.apiUrl+'index.php?m=Api&c=file&a=sdk',
				).then(response => {
						
						//进行数据验证
						if(response.body.status != 1){
							//显示错误页面
//							alert('请求错误');
							return;
						}
						if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
							//显示空数据页面
//							alert('没有数据');
							return;
						}
//							document.getElementsByClassName('commonfoot')[0].style.display='block';
//							document.getElementsByClassName('commonfoot')[0].style.position='relative';
						//数据绑定
						this.sdkName = response.body.data.name;
						this.sdkAbstract = response.body.data.abstract;
						this.sdkSize = response.body.data.filesize;
						this.sdkUrl = response.body.data.fileurl;
						this.sdkEdition = response.body.data.edition;

			}, response => {
//				console.log("error");
			});
			this.$nextTick(function(){
				_this.bodyheight =  document.body.clientHeight;
				document.getElementsByTagName('body')[0].style.height=_this.bodyheight+'px'
				console.log(_this.bodyheight,'1131')
			})
			
		},
		beforeDestroy(){
			document.getElementsByTagName('body')[0].style.height='100%'
		},
		methods:{
			//判断是否登录
			isLogin(){
				
				//判断当前是否为登录状态
				if(typeof sessionStorage.getItem('usercode') == "undefined" || sessionStorage.getItem('usercode') == null || sessionStorage.getItem('usercode') == ""){
					
					//弹出登录页面
					
					//显示登录页面
//					this.$refs.commonhead.flag = true;
					this.$message({
								message: '请先登录',
								type: 'warning',
								dangerouslyUseHTMLString:true,
								customClass: 'message-warning',
							});
					return false;
				}else{
					return true;
				}
			},
			//下载文件
			download(){
				let _this=this;
				document.getElementsByClassName('commonfoot')[0].style.display='block';
				if(this.isLogin()){
					_hmt.push(['_trackEvent', 'down', 'download']);
					window.location.href = _this.apiUrl+'index.php?m=Api&c=file&a=downLoadSDK&url='+this.sdkUrl+'&filename='+this.sdkName+'.zip&usercode='+sessionStorage.getItem('usercode');
				}
			}
		}
	}
</script>

<style scoped="scoped"> 
	#downloadwrap{
		height: 100%; 
		background: #F3F3F3;
	}
	.downloadlogo{		
		width: 100%;
		height: 155px;
		/*background: #003795 url(../assets/images/downlogo.png) no-repeat center;*/
		background: #003795 url(../assets/images/bg.png) no-repeat center;
	    line-height: 2.066667rem;
	}
	.downloadlogo>div{
		color: #fff;
		font-size: 24px;
		font-weight: bold;
	}
	.downloadmain>h3{
		margin-top: 80px;
		font-size: 20px;
		color: #132332;
	}
	.downloadmain>h6{
		height: 80px;
		line-height: 80px;
		font-size: 16px;
		color: #CDCDCD;
	}
	.sdkcircle{
		border-bottom: 1px solid #F3F3F3;
		border-radius: 50%;
		width: 195px;
		height: 195px;
		margin: 10px auto;
		background: url(../assets/images/DGdownbg.png) no-repeat center;
		background-size:100% 100% ;
	}
	.sdkcircle h4{
		width: 100%;
		text-align: center;
		margin: 20px 0;padding-top: 62px;color: #303D4D;
	}
	.sdkcircle h5{
		text-align: center;
		width: 100%;
		margin: 20px 0;color: #4B80D3;
	}
	.downloadmain>ul{
		width: 600px;
		display: flex;
		justify-content: space-around;
		margin:0px auto;
		margin-top: 55px;
		padding-bottom: 60px;
	}
	.downloadmain>ul li{
		list-style: none;
		height: 40px;
		line-height: 40px;
		width: 140px;
		border-radius: 20px;
		color: white;
		background: #076BF2;
	}
	.downloadmain>ul li a{
		display: inline-block;
		width: 100%;
		text-decoration: none;
		color:white;
	}
</style>


// WEBPACK FOOTER //
// src/views/downLoad.vue